
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import 'swiper/css';
import 'swiper/css/navigation';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isAndroid, isDesktop, isIOS, isMobile } from 'react-device-detect';

import _ from 'lodash';
import { downloadAppUrl } from '@src/constants/DownloadApp';
import { useRouter } from 'next/router';

const SlideImg = [
  '/images/downLoadApp/light/detail_01.png',
  '/images/downLoadApp/light/detail_02.png',
  '/images/downLoadApp/light/detail_03.png',
  '/images/downLoadApp/light/detail_04.png',
  '/images/downLoadApp/light/detail_05.png',
  '/images/downLoadApp/light/detail_06.png',
  '/images/downLoadApp/light/detail_07.png',
];

const DeviceType = {
  ios: 'ios',
  android: 'android',
};

const Index = (props: any) => {
  const [isMount, setIsMount] = useState(false);

  const router = useRouter();

  const isMobileAndroid = isMobile && isAndroid;
  const isMobileIos = isMobile && isIOS;

  useEffect(() => {
    setIsMount(true);
  }, []);

  /**
   * ANCHOR: IOS 다운로드 앱 QR 코드 개선
   * 기존 설치 버튼 클릭해야했던 부분으로 자동으로 설치 되게 처리 함
   */
  useEffect(() => {
    const isIosType =
      _.has(router.query, 'type') && router.query.type === DeviceType.ios;
    if (isIosType && isMobileIos) {
      const getIosInstallBtn = document.getElementById('downloadBtnIos');
      if (!getIosInstallBtn) return;
      getIosInstallBtn.click();
    }
  }, [router]);

  useEffect(() => {
    router.replace('/');
  }, []);

  if (!isMount) return null;

  return (
    <>
      {isDesktop && (
        <div className="w-full max-w-[750px] my-0 mx-auto bg-[#e9e9e9]">
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/btn_top_pc.jpg"
            alt=""
          />
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/cont_01.jpg"
            alt=""
          />
          <div className="px-[25px] mb-[30px]">
            <Swiper
              lazy={{ loadPrevNext: true, loadPrevNextAmount: 3 }}
              effect="slide"
              slidesPerView={1.5}
              spaceBetween={7}
              direction="horizontal"
            >
              {SlideImg.map((item, index) => {
                return (
                  <SwiperSlide
                    key={index}
                    className="rounded-[15px] overflow-hidden"
                  >
                    <img src={item} alt="" />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>

          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/android_01.jpg"
            alt=""
          />
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/android_02.jpg"
            alt=""
          />
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/IOS_01.jpg"
            alt=""
          />
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/IOS_02.jpg"
            alt=""
          />
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/IOS_03.jpg"
            alt=""
          />
          <img
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/IOS_04.jpg"
            alt=""
          />
        </div>
      )}

      {isMobileAndroid && (
        <div className="w-full max-w-[750px] my-0 mx-auto bg-[#e9e9e9]">
          <a href="#">
            <img
              className="mx-auto mt-0"
              src="/images/downLoadApp/light/btn_top_m.jpg"
              onClick={e => {
                e.preventDefault();
                // TODO:다운로드 통계 개선
                // const appGroup = isSafari ? 1 : 2;
                // setAppDownloadCount(appGroup);
                // TODO:다운로드 통계 개선

                window.open(
                  downloadAppUrl(process.env.REACT_APP_ENVIRONMENT).android,
                  '_blank',
                );
              }}
              alt=""
            />
          </a>
          <div className="px-[25px] mb-[30px]">
            <Swiper
              lazy={{ loadPrevNext: true, loadPrevNextAmount: 3 }}
              effect="slide"
              slidesPerView={1.5}
              spaceBetween={7}
              direction="horizontal"
            >
              {SlideImg.map((item, index) => {
                return (
                  <SwiperSlide key={`item-${index}`}>
                    <img src={item} alt="" />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <img src="/images/downLoadApp/light/android_01.jpg" alt="" />
          <img src="/images/downLoadApp/light/android_02.jpg" alt="" />
        </div>
      )}

      {isMobileIos && (
        <div className="w-full cursor-pointer max-w-[750px] my-0 mx-auto bg-[#e9e9e9]">
          <img
            id="downloadBtnIos"
            className="mx-auto mt-0"
            src="/images/downLoadApp/light/btn_top_m.jpg"
            onClick={e => {
              window.location.href = downloadAppUrl(
                process.env.REACT_APP_ENVIRONMENT,
              ).ios;
            }}
            alt=""
          />
          <div className="px-[25px] mb-[30px]">
            <Swiper
              lazy={{ loadPrevNext: true, loadPrevNextAmount: 3 }}
              effect="slide"
              slidesPerView={1.5}
              spaceBetween={7}
              direction="horizontal"
            >
              {SlideImg.map((item, index) => {
                return (
                  <SwiperSlide key={index}>
                    <img src={item} alt="" />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <img src="/images/downLoadApp/light/IOS_01.jpg" alt="" />
          <img src="/images/downLoadApp/light/IOS_02.jpg" alt="" />
          <img src="/images/downLoadApp/light/IOS_03.jpg" alt="" />
          <img src="/images/downLoadApp/light/IOS_04.jpg" alt="" />
        </div>
      )}
    </>
  );
};

export default Index;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/download/app',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  